import type { AvatarOption, PersonaOption, RepositoryOption } from './workspace-resources';

/**
 * What the boards D69 show besides the directory (repositories, personas), for
 * `/desktop-preview…` and tests. Never read outside a preview.
 */

export const PREVIEW_REPOSITORIES: RepositoryOption[] = [
  { id: 'repo-crowdex', name: 'PersoJonas/crowdex' },
  { id: 'repo-site', name: 'crowlingo/site' },
  { id: 'repo-api', name: 'crowlingo/api' },
  { id: 'repo-dotfiles', name: 'PersoJonas/dotfiles' },
];

export const PREVIEW_PERSONAS: PersonaOption[] = [
  { id: 'developer', name: 'Developer', agentName: 'Claude Code' },
  { id: 'reviewer', name: 'Reviewer', agentName: 'Codex' },
  { id: 'designer', name: 'Designer', agentName: 'Claude Code' },
];

/** The call plugin's personas of the boards: the avatars assistants speak as. */
export const PREVIEW_AVATARS: AvatarOption[] = [
  { id: 'marie', name: 'Marie' },
  { id: 'paul', name: 'Paul' },
];
